export const STATSIG_EXPERIMENTS = {
    CSM_AI_AGENT_ON_SAC: 'csm-ai-agent-on-sac',
    SAC_SEARCH_AI: 'sac-search-ai-experiment'
};

interface ExperimentDefaults {
    'csm-ai-agent-on-sac': { agent_enabled: boolean };
    'sac-search-ai-experiment': { ai_dialog_enabled: boolean };
}

/** These are the parameters passed into experiments in Statsig. */
export const STATSIG_EXPERIMENTS_DEFAULTS: ExperimentDefaults = {
    'csm-ai-agent-on-sac': {
        agent_enabled: false
    },
    'sac-search-ai-experiment': {
        ai_dialog_enabled: false
    }
};
